import { render, staticRenderFns } from "./questionnaire_siting.vue?vue&type=template&id=f4e97940&scoped=true&"
import script from "./questionnaire_siting.vue?vue&type=script&lang=js&"
export * from "./questionnaire_siting.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire_siting.vue?vue&type=style&index=0&id=f4e97940&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e97940",
  null
  
)

export default component.exports